module.exports = __webpack_public_path__ + "static/media/SPIRIT.74b30f31.png";